// extracted by mini-css-extract-plugin
export var barContainer = "_4j-0";
export var extraThin = "_4j-3";
export var fillBar = "_4j-6";
export var fillContainer = "_4j-4";
export var overflow = "_4j-8";
export var overflowContainer = "_4j-5";
export var regular = "_4j-7";
export var thick = "_4j-1";
export var thin = "_4j-2";